import debounce from 'lodash/debounce';
import React, { useEffect, useState } from 'react';
import { isBrowser } from 'utils/domUtils';

export const useScrollActions = (
  element?: string | React.RefObject<HTMLElement>,
  debounceTime = 30
) => {
  const [isSticky, setSticky] = useState(false);
  const [isElementReached, setIsElementReached] = useState(false);

  useEffect(() => {
    const handleScroll = debounce(() => {
      setSticky(window.scrollY > 0);
      if (!document || !element) return;
      if (typeof element === 'string') {
        const el = document.querySelector<HTMLElement>(element);
        if (!el) return;
        setIsElementReached(window.scrollY >= el?.offsetTop);
        return;
      }
      if (!element.current) return;
      setIsElementReached(window.scrollY >= element.current.offsetTop);
    }, debounceTime);

    if (!isBrowser()) return;
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [debounceTime, element]);

  const scrollTop = () => {
    if (isBrowser()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return {
    isSticky,
    scrollTop,
    isElementReached
  };
};
